import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ChildActivationEnd } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { CategoriaDTO } from "app/main/apps/shared/interfaces/categoria.interface";
import { ServicioDTO } from "app/main/apps/shared/interfaces/servicio.interface";
import { TipoDTO } from "app/main/apps/shared/interfaces/tipo.interface";
import { CodigosService } from "app/main/apps/shared/services/rest/codigos.service";

@Component({
  selector: 'app-dialog-nuevo-servicio',
  templateUrl: './dialog-nuevo-servicio.component.html',
  styleUrls: ['./dialog-nuevo-servicio.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class DialogNuevoServicioComponent implements OnInit {
  formulario: FormGroup;
  subFormulario: FormGroup;
  grupos:any;
  unidadTiempo:TipoDTO[];
  unidadMedida:TipoDTO[];

  categoria:CategoriaDTO;
  grupo:number;
  
  constructor(
      public dialogRef: MatDialogRef<DialogNuevoServicioComponent>,
      private fb: FormBuilder,
      private _codigosSrvc:CodigosService,
      @Inject(MAT_DIALOG_DATA) public data: any,
      //@Inject(MAT_DIALOG_DATA) public categoria: CategoriaDTO,
  ) {
    this.categoria = data.categoria;
    this.grupo=data.grupo;
  }

  ngOnInit(): void {
    this._codigosSrvc.fetchUnidadesTiempo().subscribe(resp=>{
      this.unidadTiempo=resp;
    });

    this._codigosSrvc.fetchUnidadesMedida().subscribe(resp=>{
      this.unidadMedida=resp;
    });

    this.grupos=this.categoria.grupos;
    this.initForm()
  }

  initForm() {
    this.formulario = this.fb.group({
        desde: [,{ validators: [Validators.required] }],
        hasta: [,{ validators: [Validators.required] }],
        medida: [,{ validators: [Validators.required] }],
        tiempo: [,],
        grupo: [this.grupo,{ validators: [Validators.required] }],
        nombre: [,{ validators: [Validators.required] }],  
      });
    this.categoria.atributos.forEach(e=>{
      this.formulario.addControl("attr_" + e.descripcion,new FormControl('', [ Validators.required ]))
    })
  }

  get desde() {
    return this.formulario.get("desde");
  }

  get hasta() {
    return this.formulario.get("hasta");
  }

  get medida() {
    return this.formulario.get("medida");
  }

  get tiempo() {
    return this.formulario.get("tiempo");
  }

  get nombre() {
    return this.formulario.get("nombre");
  }


  
}


